import React from "react";
import styles from "../Modules/Writing.module.css";
import n1 from "../Media/Pictures/articles/n1.webp";

const articles = [
  {
    id: 1,
    title: "How to Choose What Dependency or Package Version to Update To",
    excerpt:
      "A practical guide to semantic versioning and dependency management — what the version numbers actually mean, and how to make informed decisions when installing or updating packages.",
    tags: ["Semantic Versioning", "Dependency Management", "Backend"],
    date: "Oct 2023",
    readTime: "5 min read",
    url: "https://medium.com/@elmanioui.soulaimane/how-to-choose-what-application-dependency-or-package-version-to-update-to-4f0e70ad4275",
    image: n1,
  },
];

function Writing() {
  return (
    <div id="writing" className={styles.writing}>
      <div className={styles.heading}>
        <span className={styles.eyebrow}>Blog</span>
        <h2>Articles</h2>
      </div>

      <div className={styles.cards}>
        {articles.map((article) => (
          <article key={article.id} className={styles.card}>
            {article.image && (
              <div className={styles.imageWrapper}>
                <img src={article.image} alt={article.title} className={styles.coverImage} />
              </div>
            )}
            <div className={styles.body}>
            <div className={styles.meta}>
              <span className={styles.date}>{article.date}</span>
              <span className={styles.dot}>·</span>
              <span className={styles.readTime}>{article.readTime}</span>
            </div>
            <h3 className={styles.title}>{article.title}</h3>
            <p className={styles.excerpt}>{article.excerpt}</p>
            <div className={styles.footer}>
              <div className={styles.tags}>
                {article.tags.map((tag) => (
                  <span key={tag} className={styles.tag}>{tag}</span>
                ))}
              </div>
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.readLink}
              >
                Read on Medium
                <svg xmlns="http://www.w3.org/2000/svg" height="0.85em" viewBox="0 0 448 512" className={styles.arrow}>
                  <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
                </svg>
              </a>
            </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Writing;
